import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import PageContainer from '../../../../components/layout/page-container/PageContainer';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import UsersListBig from '../../../../components/reusable/users-list/UsersListBig';
import withRouter from '../../../../hoc/with-router';
import { useNotFound } from '../../../../hooks/useNotFound';
import { useGetUserSubscriptions } from '../../../../redux/api/users/usersApi';
import { useStyles } from './UserSubscriptions.styles';

function UserSubscriptions(props) {
  const { params } = props;
  const { t, i18n } = useTranslation();
  const {
    data: subscriptions,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetUserSubscriptions(params.userId);
  useNotFound(!isFetching && subscriptions === undefined);
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);

  useRegisterPageContainerError({
    errors: isError && error ? [error] : [],
    isLoading: isFetching && subscriptions === undefined,
    hasData: Boolean(subscriptions?.length),
    onRetry: handleRetry,
  });

  return (
    <PageContainer
      title={t('users.subscriptions')}
      backButton
      onRefresh={() => void refetch()}>
      <div className={classes.subscriptionsWrapper}>
        <UsersListBig
          users={subscriptions}
          showSearch
          withoutTabs
          isLoading={isFetching && subscriptions === undefined}
          isError={isError}
        />
      </div>
    </PageContainer>
  );
}

export default withRouter(UserSubscriptions);
